module.exports = __webpack_public_path__ + "img/face.1777510d.svg";